var map = {
	"./alg-wc-wish-list": [
		"./src/js/modules/alg-wc-wish-list.js",
		"src_js_modules_alg-wc-wish-list_js"
	],
	"./alg-wc-wish-list.js": [
		"./src/js/modules/alg-wc-wish-list.js",
		"src_js_modules_alg-wc-wish-list_js"
	],
	"./iconpicker-manager": [
		"./src/js/modules/iconpicker-manager.js",
		"src_js_modules_iconpicker-manager_js"
	],
	"./iconpicker-manager.js": [
		"./src/js/modules/iconpicker-manager.js",
		"src_js_modules_iconpicker-manager_js"
	],
	"./multi-wishlist": [
		"./src/js/modules/multi-wishlist.js",
		"src_js_modules_multi-wishlist_js"
	],
	"./multi-wishlist.js": [
		"./src/js/modules/multi-wishlist.js",
		"src_js_modules_multi-wishlist_js"
	],
	"./social": [
		"./src/js/modules/social.js",
		"src_js_modules_social_js"
	],
	"./social.js": [
		"./src/js/modules/social.js",
		"src_js_modules_social_js"
	],
	"./thumb-btn-positioner": [
		"./src/js/modules/thumb-btn-positioner.js",
		"src_js_modules_thumb-btn-positioner_js"
	],
	"./thumb-btn-positioner.js": [
		"./src/js/modules/thumb-btn-positioner.js",
		"src_js_modules_thumb-btn-positioner_js"
	],
	"./wish-list-counter": [
		"./src/js/modules/wish-list-counter.js",
		"src_js_modules_wish-list-counter_js"
	],
	"./wish-list-counter.js": [
		"./src/js/modules/wish-list-counter.js",
		"src_js_modules_wish-list-counter_js"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./src/js/modules lazy recursive ^\\.\\/.*$";
module.exports = webpackAsyncContext;